export enum TipoFiltro {
  UF = 1,
  Cidade = 2,
  Cargo = 3,
  FaixaSalarial = 4,
  Regime = 5,
  Secretaria = 6,
  TipoContato = 7,
  Abrangencia = 8,
  Idade = 9,
  PersonaCredito = 10,
}
